"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorPageContentWrapper = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const banner_1 = __importDefault(require("@kyruus/banner"));
exports.ErrorPageContentWrapper = (0, styled_1.default)(banner_1.default) `
  width: 100%;
`;
//# sourceMappingURL=styles.js.map